// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"24aadb70","664":"ad6d84f4","871":"12eebdf2"}[chunkId] + ".chunk.js";
};